import axios from 'axios';
import utilsService from '@/api/utilsService';

const base = `${process.env.VUE_APP_API_URL}/api/dashboard-master`;

function headers() {
  return { Authorization: `Bearer ${utilsService.getToken()}` };
}

const dashboardMasterService = {
  getKpis(idEmpresa = 0) {
    return axios
      .get(`${base}/kpis`, { params: { idEmpresa }, headers: headers() })
      .then(r => r.data);
  },

  getMateriales({ idEmpresa = 0, page = 1, pageSize = 50, search = '' } = {}) {
    return axios
      .get(`${base}/materiales`, {
        params: { idEmpresa, page, pageSize, search: search || undefined },
        headers: headers(),
      })
      .then(r => r.data);
  },

  getClientes() {
    return axios
      .get(`${base}/clientes`, { headers: headers() })
      .then(r => r.data);
  },

  getRfm() {
    return axios
      .get(`${base}/rfm`, { headers: headers() })
      .then(r => r.data);
  },

  getCategorias(idEmpresa = 0, lang = 'es') {
    return axios
      .get(`${base}/categorias`, { params: { idEmpresa, lang }, headers: headers() })
      .then(r => r.data);
  },

  getTimeline(idEmpresa = 0) {
    return axios
      .get(`${base}/timeline`, { params: { idEmpresa }, headers: headers() })
      .then(r => r.data);
  },

  getAlertas(idEmpresa = 0) {
    return axios
      .get(`${base}/alertas`, { params: { idEmpresa }, headers: headers() })
      .then(r => r.data);
  },

  getClases(idEmpresa = 0, lang = 'es') {
    return axios
      .get(`${base}/clases`, { params: { idEmpresa, lang }, headers: headers() })
      .then(r => r.data);
  },

  getMarcas(idEmpresa = 0, top = 10, lang = 'es') {
    return axios
      .get(`${base}/marcas`, { params: { idEmpresa, top, lang }, headers: headers() })
      .then(r => r.data);
  },

  getDesgloce(idEmpresa) {
    return axios
      .get(`${base}/desglose`, { params: { idEmpresa }, headers: headers() })
      .then(r => r.data);
  },

  getVentasTimeline(idEmpresa = 0) {
    return axios
      .get(`${base}/ventas-timeline`, { params: { idEmpresa }, headers: headers() })
      .then(r => r.data);
  },

  getFamilias(idEmpresa = 0, lang = 'es') {
    return axios
      .get(`${base}/familias`, { params: { idEmpresa, lang }, headers: headers() })
      .then(r => r.data);
  },

  getSegmentos(idEmpresa = 0, lang = 'es') {
    return axios
      .get(`${base}/segmentos`, { params: { idEmpresa, lang }, headers: headers() })
      .then(r => r.data);
  },

  getConfianzaDistribucion(idEmpresa = 0) {
    return axios
      .get(`${base}/confianza-distribucion`, { params: { idEmpresa }, headers: headers() })
      .then(r => r.data);
  },

  getVentasMonitoreo(idEmpresa = 0) {
    return axios
      .get(`${base}/ventas-monitoreo`, { params: { idEmpresa }, headers: headers() })
      .then(r => r.data);
  },

  // Reconstruye la tabla de reporteria on-demand. Tambien corre sola de noche.
  consolidar() {
    return axios
      .post(`${base}/consolidar`, {}, { headers: headers() })
      .then(r => r.data);
  },

  getConsolidacionEstado() {
    return axios
      .get(`${base}/consolidacion-estado`, { headers: headers() })
      .then(r => r.data);
  },
};

export default dashboardMasterService;
